

export enum SubjectType {
  //  1 表示填空题，2 表示客观题，3 表示解答题，4表示英文作文，5表示语文作文，6表示选做题
  Blank = 1,
  Objective,
  Answer,
  writeEn,
  write,
  Choose,
}

/**
 * 大题
 */
export interface AcCardQuestTh {
  fkCardGuid: string; // 大题试题GUID
  questTh_Guid: string; // 试题GUID
  questTh: string; // 当前大题号
  questTh_name: string; // 题目名称
  questTh_type: number; // 大题题型，1客观题 2填空题 3解答题 4作文题_英 5作文题_语 6选做题
  fkQuestTypeGuid: string; // 大题题型Guid
  questTh_score: number; // 大题分值
  questTh_sort: number; // 大题排序
  questTh_thNum: number; // 小题个数
  questTh_operation: number; //小题组是否修改
  questTh_isSmall: number;// 是否小题给分
  quest_list: Array<Quest>; // 大题下小题列表
}

/**
 * 小题
 */
export interface Quest {
  quest_Guid?: string; // 小题guid
  quest_th?: string; // 当前大题号
  quest_sechth: string;// 当前小题号 这个字段比较关键 小题号字符串需要分割
  quest_score?: number; // 当前题目得分
  quest_option?: number;// 客观题选项数
  quest_bfscore?: number; // 当前题目部分得分
  quest_bfSetting?: string; // 当前题目得分设置
  quest_blank?: number;// 空格数
  quest_sort?: number; // 排序
  fkQuestTypeGuid?: string; // 小题题型Guid 这里应该就只有客观题需要，用来分类单选多选判断
}


export interface Questinon {
  questType_Guid: string; // 试题Guid
  questType_name: string; // 试题名称
}
export interface AcQuestType {
  questType_Guid: string;
  questType_name: string;
  questinonList: Array<Questinon> // 试题小分类list
}

